export const profits = {
  period_start: '計測開始日',
  period_end: '計測終了日',
  add_search: '＋検索条件をふやす',
  area: 'エリア',
  add_edit: '追加・変更',
  company_name: '企業名',
  close_result_search: '検索結果をすべて閉じる',
  open_result_search: '検索結果をすべて開く',
  title_result: '売上金額',
  amount: '売上金額',
  total_amount: '所属売上金額',
  total_amount_staff: 'メンバー売上金額',
  company_amount: '企業売上金額',
  off_axis_amount: 'オフアクシス売上金額',
  close: 'とじる▲',
  open: 'ひらく▼',
  btn_export: 'データを出力',
  export_label: 'データ抽出を行います',
  title_select_area: 'エリアを選択',
  title_select_genre: 'ジャンルを選択',
  search_result: '検索結果：{0}件',
  period: '期間',
  industries: '業種',
  seats: '席数',
  genres: 'ジャンル',
  no_selected: '指定なし',
  dialog_export: {
    btn_export: '抽出する',
    filter_by_time: '▼「西暦（年）／月」を選択してください',
    filter_by_company: '▼「企業名」を選択してください',
    filter_by_shop: '▼「所属名」を選択してください（任意）',
    company_filter_placeholder: '企業名を選択',
    shop_filter_placeholder: '所属名を選択',
    compnay_profit_filename: '{0}_売上照会.csv',
    shop_profit_filename: '{0}_{1}売上照会.csv',
    staff_profit_filename: '{0}_{1}売上照会.csv',
    errors: {
      required: '※{0}は必須です'
    }
  },
  select_area: {
    btn_search: 'この条件で検索する',
    btn_clear: '選択をクリア',
    selected_area: '選択したエリア',
    hint_result: 'この条件にヒットした検索結果',
    ken: '件'
  },
  select_genre: {
    btn_search: 'この条件で検索する',
    btn_clear: '選択をクリア',
    selected_genre: '選択したジャンル',
    hint_result: 'この条件にヒットした検索結果',
    ken: '件'
  },
  company: {
    title: '企業別売上',
    search_title: '企業検索結果：{0}社（全{1}社中）',
    industries: '業種',
    columns: {
      company_name: '企業名',
      industries: '業種',
      profits: '売上金（ココロン）'
    },
    export: {
      title: '企業別売上の'
    }
  },
  year_month: '年月',
  company_name: '企業名',
  shop: {
    title: '所属別売上',
    search_title: '所属検索結果：{0}件（全{1}件中）',
    seats: '席数',
    genres: 'ジャンル',
    placeholder_search_text:  '企業名、または所属名',
    columns: {
      shop_name: '所属名',
      company_name: '企業名',
      genre_name: 'ジャンル',
      seat_name: '席数',
      profits: '売上金（ココロン）'
    },
    export: {
      title: '所属別売上の'
    },
    partner: {
      placeholder_search_text:  '所属名',
    }
  },
  staff: {
    title: 'メンバー別売上',
    search_title: 'メンバー検索結果：{0}件（全{1}件中）',
    seats: '席数',
    genres: 'ジャンル',
    placeholder_search_text:  '企業名、または所属名',
    columns: {
      shop_name: '所属先',
      staff_fullname: 'メンバー名',
      genre_name: 'ジャンル',
      seat_name: '席数',
      profits: '売上金（ココロン）'
    },
    export: {
      title: 'メンバー別売上の'
    }
  },
}
